module.exports = __webpack_public_path__ + "static/media/image4.693a8a41.jpeg";